import useHost from '@app/utils/useHost'
import { useMyIntl } from 'hooks'

// 策略K线 symbolCode处理 不影响合约
export const kline_busLine = {
    strategy_spot: 'strategy_spot',
    // 注意： ！！！ 因为合约只有U本位合约的K线图 所币对后缀只有_UMCBL 后续有币本位永续合约、币本位交割合约
    strategy_futures: 'strategy_futures'
}

export const strategySymboleId = {
    'future-strategy': {
        lineCode: 10,
        depthInstType: 'umcbl',
        instType: 'umcbl',
        strategy: 'umcbl',
        symbolId: 'BTCUSDT_UMCBL'
    },
    'spot-strategy': {
        lineCode: 1,
        depthInstType: 'sp',
        instType: 'spbl',
        strategy: 'spbl',
        symbolId: 'BTCUSDT_SPBL'
    }
}

export const strategyBusinessLineCode = {
    '10': 'future-strategy',
    '1': 'spot-strategy'
}

//盈亏参照
export const PROFIT_TYPEENUM = {
    total: 1,
    first: 2
}
export const APPEND_TYPEENUM = {
    last: 2,
    first: 1
}

export const strategyTypes = {
    1: '网格策略',
    2: '反向网络',
    3: '无线网络'
}
export const strategyTypesEnum = {
    grid: 1,
    dca: 2,
    timing: 5,
    neutral: 3,
    cta: 8,
    wise: 10,
    hoard: 12, // 策略维度的大类型 strategyType:12
    tv: 13, // 交易信号
    moon: 1 // 天地网格也是网格的一类
}
export  enum strategyTypesEnumMap {
    grid = 1,
    dca= 2,
    timing= 5,
    cta=8,
    wise= 10,
    hoard=12, // 策略维度的大类型 strategyType:12
    tv= 13, // 交易信号
}




export const SocketStrategyTypeEnums = {
    '1': {
        old_grid: 1,
        dca: 3,
        grid: 8,
        timing: 7,
        hoard: 19,
        moon: 22,
        cta: 15 // 现货cta
    },
    '10': {
        old_grid: 2,
        dca: 4,
        grid: 9,
        cta: 16, // 合约cta
        wise: 17, // wise智投
        tradingview: 20,
        tv: 20,
        moon: 21
    }
}

export const strategyTypeEnums = {
    '1': {
        grid: 1,
        dca: 3,
        // grid: 8,
        timing: 7,
        hoard: 19,
        moon: 22,
        cta: 15 // 现货cta
    },
    '10': {
        grid: 2,
        dca: 4,
        // grid: 9,
        cta: 16, // 合约cta
        wise: 17, // wise智投
        tradingview: 20,
        tv: 20,
        moon: 21
    }
}
export const dcaTypeEnum = {
    1: {
        1: 'strategy_entry.up', //正向
        2: 'strategy_entry.down' // 反向
    },
    10: {
        1: 'calculator_text.calc_position_long', //多头
        2: 'calculator_text.calc_position_short' // 空头
    }
}

export const dcaTypes = {
    normal: 1,
    reversel: 2,
    long: 1,
    short: 2,
    neutral: 3
}
export enum StrategyStatusTypes {
    Unstart = 1, // 待启动
    Initialize = 2, // 初始化
    Running = 3, // 运行中
    Running2 = 5, // 运行中
    Terminate = 4, // 终止
    Terminating = 6, // 终止中
    Terminated = 8 // 已终止
}
export const strategyStatusEnum = {
    running: 3,
    running2: 5,
    stop: 8,
    stopping: 6
}
export const StrategyStatusLocaleKey = {
    1: 'strategy_grid_text.strategy_status_text_1', // 待启动
    5: 'strategy_grid_text.strategy_status_text_3', // 运行中
    6: 'strategy_grid_text.overing', // 终止中
    8: 'strategy_grid_text.strategy_status_text_8' // 已终止
}
export const StrategyTypeLocaleKey = {
    1: 'strategy_grid_text.grid_strategy_title',
    11: 'strategy_grid_text.forward_grid', // 业务线+网格类型=币币=正向网格
    12: 'strategy_grid_text.backward_grid', // 币币+反向网格
    101: 'strategy_grid_text.contract_long_grid', // 业务线+网格类型=合约=多头网格
    102: 'strategy_grid_text.contract_short_grid' // 合约+空头网格
}
export const StrategyStopReason = {
    1: 'strategy_grid_text.termination_by_insufficient_balance', //可用资金不足，策略终止
    2: 'strategy_grid_text.manual_termination', //手动终止
    3: 'strategy_grid_text.take_profit_termination', //止盈终止
    4: 'strategy_grid_text.take_stop_termination', //止损终止
    6: 'strategy_grid_text.cancel_to_termination', //撤单终止
    7: 'trade.plan.fail_reason_20003', //下单失败,
    8: 'strategy_grid_text.follow_termination', //跟单终止
    9: 'strategy_grid_text.sub_profit_termination', //订阅止盈终止
    10: 'strategy_grid_text.sub_loss_termination', //订阅止损终止
    11: 'auto_invest.order_fail', //定投连续下单3次失败
    12: 'auto_invest.coin_down', //比对下架终止
    13: 'strategy_assets_fail', //资金划转失败
    14: 'neutral.max_stop_price', //最高价终止
    15: 'neutral.min_stop_price', //最低价终止
    16: 'cta.explosion_termination', // 爆仓终止
    17: 'strategy.moving_grid.stop_reason', // 移动失败终止
    18: 'strategy.strategy_coupons.stop_reason', // 系统终止
    19:'strategy.strategy_coupons.handle_sub_position_end', // 手动减仓终止
    20:'strategy.strategy_coupons.stop_price_achieve', // 达到终止价格
}

export const StopReasonDetail = {
    balance_available_not_enough: 'strategy.order_error.balance_available_not_enough', //资产可用不足
    open_psition_limit: 'strategy.order_error.open_psition_limit', //此合约暂不支持开仓操作--
    delegate_count_cannot_high_max_count_error: 'strategy.order_error.delegate_count_cannot_high_max_count_error', //委托数量大于最大可开数量--
    risk_limit_not_open: 'strategy.order_error.risk_limit_not_open', //因风控限制，您当前最大可开仓超出最大限制，如有疑问请联系客服
    not_exceed_un_deal_delegate_orders_limit:
        'strategy.order_error.not_exceed_un_deal_delegate_orders_limit', //未成交委托单总数过高
    place_count_min_cost_limit: 'strategy.order_error.place_count_min_cost_limit', //触发最小下单价值限制--
    mark_open_price_limit: 'strategy.order_error.mark_open_price_limit', //合理标记价格偏离盘口过大，您当前杠杆开仓风险较高
    fatal_error_use_ssm_delegate_type_in_ssm: 'strategy.order_error.fatal_error_use_ssm', //单边持仓时委托类型也必须是单边持仓类型
    delegate_price_cannot_high_max_price_error: 'strategy.order_error.delegate_price_cannot_high_max_price_error', //委托价格大于最高买价--
    error_duplicate_clientoid: 'strategy.order_error.error_duplicate_clientoid', //参数校验异常
    trade_lever_limit: 'strategy.order_error.trade_lever_limit', // 您当前为交易员身份，超出最大可用杠杆倍数
    delegate_price_cannot_low_min_price_error: 'strategy.order_error.delegate_price_cannot_low_min_price_error', // 委托价格小于最低卖价--
    biz_limit_error: 'strategy.order_error.biz_limit_error', // 当前业务已冻结，如有疑问请联系客服
    account_not_in_normal_status: 'strategy.order_error.account_not_in_normal_status', //账户非正常状态
    param_validate_error: 'strategy.order_error.error_duplicate_clientoid', //参数校验异常
    trader_open_min_check_fail: 'strategy.order_error.trader_open_min_check_fail', //低于交易员最少开仓数量
    unsupported_operations: 'strategy.order_error.unsupported_operations', //不支持的操作
    position_available_not_enough: 'strategy.order_error.position_available_not_enough', //剩余仓位不足
    position_total_not_enough: 'strategy.order_error.position_available_not_enough', //剩余仓位不足
    area_user_use_limit: 'strategy.order_error.area_user_use_limit', //由于监管要求，您被限制下单，给您带来不便，敬请谅解，如有疑问，请联系客服
    dc_not_hgmc_error: 'strategy.order_error.dc_not_hgmc_error', //委托数量不能超过对应档位的最大量--
    close_no_position: 'strategy.order_error.close_no_position', //暂无仓位可平--
    exceed_max_hold_position_limit: 'strategy.order_error.exceed_max_hold_position_limit_new', //总持仓超过了当前持仓条数限制
    20206: 'strategy.order_error.login_user_abnormal_status', //当前登录用户状态异常，如有疑问请联系客服
    23126: 'mark_text.plan_mark.user_23126', //遵循相关法律法规，根据您的当前登录信息，为方便您的使用，请先进行KYC--
    34443: 'strategy.order_error.area_user_use_limit', //由于监管要求，您被限制下单，给您带来不便，敬请谅解，如有疑问，请联系客服
    20202: 'strategy.order_error.user_frozen', //用户被冻结
    '02014': 'strategy_grid_text.insufficient_balance', //余额不足--
    20106: 'price_alert.no_user', //用户不存在--
    50018: 'strategy.order_error.price_high', //价格太高
    50014: 'strategy.order_error.risk_limit_order_fail', //风控限制，下单失败
    50066: 'strategy.order_error.risk_limit_order_fail', //风控限制，下单失败
    50052: 'strategy.order_error.risk_limit_order_fail', //风控限制，下单失败
    50017: 'strategy.order_error.price_low', //价格太低
    50049: 'strategy.order_error.page_num_be_pass_integer', //页码必须是大于0的整数
    50046: 'strategy.order_error.trade_pairs_not_open_trade', //交易对未开放交易
    '000001': 'strategy.order_error.error_duplicate_clientoid', //参数校验异常
    24391: 'strategy.order_error.identity_process', //您的身份认证还在审核中,请等待审核通过后再试此功能
    50056: 'strategy.order_error.available_insufficient', //可用不足，剩余部分处于跟单或带单的冻结资产，暂不可使用
    23108: 'strategy.order_error.area_user_use_limit', //由于监管要求，您被限制下单，给您带来不便，敬请谅解，如有疑问，请联系客服
    23140: 'strategy.order_error.user_not_have_permission', //用户无此权限
    22100: 'strategy.order_error.current_freeze_contant_customer', //当前业务已冻结，如有疑问请联系客服
    24303: 'strategy.order_error.account_logout_once_again_use', //该账号已注销，不可再次使用
    34450: 'strategy.order_error.located_limit_tip', //您位于我们服务限制的国家地区，请完成KYC认证。如有疑问请联系客服
    manual_end:'strategy.manual_end',//手动终止
    expire_time_end:'strategy.expire_time_end',//策略过期终止
    stop_price_achieve:'strategy.stop_price_achieve',//达到终止价格
    delivery_period_place_limit:'strategy.delivery_period_place_limit',//交割中，禁止下单
    delivery_before_limit:'strategy.delivery_before_limit'//临近交割，禁止开仓
}

// 网格价格模式的多语言
export const StrategyModelLocaleKey = {
    1: 'strategy_grid_text.equidistant_interval',
    2: 'strategy_grid_text.equal_interval'
}

/**
 * 太多硬编码了，映射也不好做
 */
export const STRATEGY_ENTITY_KEYS = {
    // 确认参数仅包括以下内容
    STRATEGY_NUM: 'strategyNum',
    UP_LIMIT_PRICE: 'strategyMaxPrice',
    DOWN_LIMIT_PRICE: 'strategyMinPrice',
    TOKEN_BASE_INVEST_AMOUNT: 'tokenBaseInvestAmount',
    TOKEN_QUOTE_INVEST_AMOUNT: 'tokenQuoteInvestAmount',
    STRATEGY_MODEL: 'strategyModel',
    STRATEGY_TRIGGER_PRICE: 'triggerPrice',
    // 提交参数还包括以下内容
    STRATEGY_ATTRIBUTE: 'strategyAttribute',
    STRATEGY_MODEL_GRADE: 'strategyModelGrade',
    STRATEGY_TAKE_PROFIT_PRICE: 'stopProfitPrice',
    STRATEGY_STOP_PRICE: 'stopLossPrice',
    GRID_TYPE: 'gridType',
    INVEST_TOKENS: 'investTokens',
    END_OPERATE: 'endOperate',
    TOKEN_ID: 'tokenId',
    MARGIN_MODE: 'marginMode',
    LEVERAGE: 'leverage',
    DCATYPE: 'dcaType',
    APPEND_TYPE: 'appendType',
    INVEST_TYPE: 'investType',
    FIRSTCHANGERANGE: 'firstChangeRange',
    PRICETIMES: 'priceTimes',
    AMOUNTTIMES: 'amountTimes',
    MAXAPPENDCOUNT: 'maxAppendCount',
    PROFITTYPE: 'profitType',
    TARGETPROFIT: 'targetProfit',
    TARGETLOSS: 'targetLoss',
    FIRSTPRICE: 'firstPrice',
    FIRSTAMOUNT: 'firstAmount',
    INVEST_AMOUNT: 'investAmount',
    CTA_TYPE: 'ctaType',
    INDICATOR_TYPE: 'indicatorType',
    INDICATOR_INTERVAL: 'indicatorInterval',
    MACD_EMA: 'macdEma',
    MACD_EMV: 'macdEmv',
    MACD_DIF: 'macdDif',
    BOLL_K: 'bollK',
    BOLL_N: 'bollN',
    macFast: 'macFast',
    macSlow: 'macSlow',
    rsiBarCount: 'rsiBarCount',
    rsiBuyThreshold: 'rsiBuyThreshold',
    rsiSellThreshold: 'rsiSellThreshold',
    voiBarCount: 'voiBarCount',
    voiThreshold: 'voiThreshold',
    BUSINESS_LINE: 'businessLine',
    AI_ID: 'aiId',
    STOPPRICE:'stopPrice'
}

/**
 * 基本策略实体
 */
export function createDefaultStrategy(strategyType = 1) {
    return {
        [STRATEGY_ENTITY_KEYS.STRATEGY_ATTRIBUTE]: 2, // 默认手动创建
        [STRATEGY_ENTITY_KEYS.GRID_TYPE]: strategyType, // 默认正向网格
        [STRATEGY_ENTITY_KEYS.STRATEGY_NUM]: '',
        [STRATEGY_ENTITY_KEYS.UP_LIMIT_PRICE]: '',
        [STRATEGY_ENTITY_KEYS.DOWN_LIMIT_PRICE]: '',
        [STRATEGY_ENTITY_KEYS.TOKEN_BASE_INVEST_AMOUNT]: '',
        [STRATEGY_ENTITY_KEYS.TOKEN_QUOTE_INVEST_AMOUNT]: '',
        [STRATEGY_ENTITY_KEYS.STRATEGY_MODEL]: 1, // 默认等差
        [STRATEGY_ENTITY_KEYS.STRATEGY_TRIGGER_PRICE]: '',
        [STRATEGY_ENTITY_KEYS.STRATEGY_MODEL_GRADE]: 0, // 默认没有开仓限价
        [STRATEGY_ENTITY_KEYS.STRATEGY_TAKE_PROFIT_PRICE]: '',
        [STRATEGY_ENTITY_KEYS.STRATEGY_STOP_PRICE]: '',
        [STRATEGY_ENTITY_KEYS.END_OPERATE]: 1
    }
}

/**
 * 选填项
 * @type {(string)[]}
 */
export const OptionalFields = [
    // STRATEGY_ENTITY_KEYS.TOKEN_BASE_INVEST_AMOUNT,
    STRATEGY_ENTITY_KEYS.STRATEGY_TRIGGER_PRICE,
    STRATEGY_ENTITY_KEYS.STRATEGY_TAKE_PROFIT_PRICE,
    STRATEGY_ENTITY_KEYS.STRATEGY_STOP_PRICE
]

/**
 * 抽取用于确认的策略实体
 * @param param
 * @returns {{}}
 */
export function extractConfirmParam(param) {
    let result = {}
    const requireKeys = [
        STRATEGY_ENTITY_KEYS.STRATEGY_NUM,
        STRATEGY_ENTITY_KEYS.UP_LIMIT_PRICE,
        STRATEGY_ENTITY_KEYS.DOWN_LIMIT_PRICE,
        STRATEGY_ENTITY_KEYS.INVEST_TOKENS,
        STRATEGY_ENTITY_KEYS.STRATEGY_MODEL,
        STRATEGY_ENTITY_KEYS.STRATEGY_TRIGGER_PRICE,
        STRATEGY_ENTITY_KEYS.GRID_TYPE,
        STRATEGY_ENTITY_KEYS.LEVERAGE,
        STRATEGY_ENTITY_KEYS.MARGIN_MODE,
        STRATEGY_ENTITY_KEYS.TOKEN_ID,
        STRATEGY_ENTITY_KEYS.END_OPERATE,
        STRATEGY_ENTITY_KEYS.APPEND_TYPE,
        STRATEGY_ENTITY_KEYS.INVEST_TYPE,
        STRATEGY_ENTITY_KEYS.FIRSTCHANGERANGE,
        STRATEGY_ENTITY_KEYS.PRICETIMES,
        STRATEGY_ENTITY_KEYS.AMOUNTTIMES,
        STRATEGY_ENTITY_KEYS.MAXAPPENDCOUNT,
        STRATEGY_ENTITY_KEYS.PROFITTYPE,
        STRATEGY_ENTITY_KEYS.TARGETPROFIT,
        // STRATEGY_ENTITY_KEYS.TARGETLOSS,
        STRATEGY_ENTITY_KEYS.FIRSTPRICE,
        STRATEGY_ENTITY_KEYS.LEVERAGE,
        STRATEGY_ENTITY_KEYS.FIRSTAMOUNT,
        STRATEGY_ENTITY_KEYS.STRATEGY_ATTRIBUTE,
        STRATEGY_ENTITY_KEYS.STRATEGY_MODEL_GRADE,
        STRATEGY_ENTITY_KEYS.STRATEGY_TAKE_PROFIT_PRICE,
        STRATEGY_ENTITY_KEYS.STRATEGY_STOP_PRICE,
        STRATEGY_ENTITY_KEYS.STOPPRICE
    ]
    requireKeys.forEach(key => {
        // eslint-disable-next-line no-prototype-builtins
        if (param.hasOwnProperty(key)) {
            result[key] = param[key]
        }
    })
    return result
}

export function createStrategyFromHistory(history, isViadated = true) {
    let result = {
        [STRATEGY_ENTITY_KEYS.STRATEGY_ATTRIBUTE]: 2
    }
    const requireKeys = [
        STRATEGY_ENTITY_KEYS.STRATEGY_NUM,
        STRATEGY_ENTITY_KEYS.UP_LIMIT_PRICE,
        STRATEGY_ENTITY_KEYS.DOWN_LIMIT_PRICE,
        STRATEGY_ENTITY_KEYS.TOKEN_BASE_INVEST_AMOUNT,
        STRATEGY_ENTITY_KEYS.TOKEN_QUOTE_INVEST_AMOUNT,
        STRATEGY_ENTITY_KEYS.STRATEGY_MODEL,
        STRATEGY_ENTITY_KEYS.STRATEGY_TRIGGER_PRICE,
        STRATEGY_ENTITY_KEYS.GRID_TYPE
    ]
    const bitMode = +history[STRATEGY_ENTITY_KEYS.TOKEN_BASE_INVEST_AMOUNT] ? 2 : 1
    const notViadatedHistory = Object.assign(history, result, {
        [STRATEGY_ENTITY_KEYS.TOKEN_BASE_INVEST_AMOUNT]: '',
        [STRATEGY_ENTITY_KEYS.TOKEN_QUOTE_INVEST_AMOUNT]: '',
        bitMode //查看是否有组合币
    })
    if (!isViadated) return notViadatedHistory

    requireKeys.forEach(key => {
        // eslint-disable-next-line no-prototype-builtins
        if (history.hasOwnProperty(key)) {
            result[key] = history[key]
        }
    })
    return result
}

export function transferAIParamsToNormalStrategy(params) {
    const { DOWN_LIMIT_PRICE, UP_LIMIT_PRICE } = STRATEGY_ENTITY_KEYS
    return {
        [DOWN_LIMIT_PRICE]: params.downLimitPrice,
        [UP_LIMIT_PRICE]: params.upLimitPrice,
        [STRATEGY_ENTITY_KEYS.STRATEGY_NUM]: params.strategyNum
    }
}

/**
 * 业务线
 */
export const BusinessLineEnum = {
    SPOT_BL: 1,
    CONTRACT_BL: 2,
    MIX_CONTRACT_BL: 3, // 废弃
    OPTION_BL: 4,
    OTC_BL: 5,
    FINANCIAL_BL: 6,
    SPOT_MIX_CONTRACT: 7,
    S_USDT_MIX_CONTRACT_BL: 8, // SUSDT混合合约，即USDT专业合约模拟盘，仅支持SUSDT保证金
    S_USD_MIX_CONTRACT_BL: 9, // SUSD混合合约，即混合合约的模拟盘
    USDT_MIX_CONTRACT_BL: 10, // USDT混合合约，即USDT专业合约，仅支持USDT保证金
    USD_MIX_CONTRACT_BL: 11 // USD混合合约，即混合合约
}

/**
 * 业务线的业务类型
 * 和撮合类型不同，每个业务线有自己的instType，用于当前委托等业务线相关的数据
 * @param businessLine
 * @returns {string}
 */
export function getBusinessLineCode(businessLine) {
    switch (businessLine) {
        case BusinessLineEnum.SPOT_BL:
            return 'spbl'
        case BusinessLineEnum.USDT_MIX_CONTRACT_BL:
            return 'umcbl'
        case BusinessLineEnum.USD_MIX_CONTRACT_BL:
            return 'dmcbl'
        default:
            return ''
    }
}

/**
 * 业务线的撮合类型
 * 合约的撮合类型是一样的，没有保证金区分，用于和撮合相关，与业务线无关的数据
 * 如：深度，k线
 * @param businessLine
 * @returns {string}
 */
export function getBusinessLineInstType(businessLine) {
    switch (businessLine) {
        case BusinessLineEnum.SPOT_BL:
            return 'sp'
        case BusinessLineEnum.USDT_MIX_CONTRACT_BL:
        case BusinessLineEnum.USD_MIX_CONTRACT_BL:
            return 'mc'
        default:
            return ''
    }
}

export const BusinessLineToLink = {
    [BusinessLineEnum.S_USDT_MIX_CONTRACT_BL]: 'susdt',
    [BusinessLineEnum.S_USD_MIX_CONTRACT_BL]: 'susd',
    [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: 'usdt',
    [BusinessLineEnum.USD_MIX_CONTRACT_BL]: 'usd'
}

export const StrategyTypeEnum = {
    DEFAULT: 0,
    POSITIVE_GRID: 1,
    NEGATIVE_GRID: 2,
    NEUTRAL_GRID: 3
}

export const CommonStrategyTypeLocale = {
    [StrategyTypeEnum.DEFAULT]: 'strategy_grid_text.strategy_trade'
}

/**
 * 币币各种策略的名称
 * @type {{'[StrategyTypeEnum.NEGATIVE_GRID]': string}}
 */
export const SpotStrategyTypeLocale = {
    [StrategyTypeEnum.POSITIVE_GRID]: 'strategy_grid_text.forward_grid',
    [StrategyTypeEnum.NEGATIVE_GRID]: 'strategy_grid_text.backward_grid'
}
export const FutureStrategyTypeLocale = {
    [StrategyTypeEnum.POSITIVE_GRID]: 'strategy_grid_text.contract_long_grid',
    [StrategyTypeEnum.NEGATIVE_GRID]: 'strategy_grid_text.contract_short_grid'
}

/**
 * 获取策略的名称
 * @param businessLine
 * @param strategyType
 * @returns {*}
 */
export function getStrategyTypeLocaleKey(businessLine, strategyType) {
    if (strategyType === 0) {
        return CommonStrategyTypeLocale[StrategyTypeEnum.DEFAULT]
    } else {
        switch (businessLine) {
            case BusinessLineEnum.SPOT_BL:
                return SpotStrategyTypeLocale[strategyType]
            case BusinessLineEnum.USDT_MIX_CONTRACT_BL:
                return FutureStrategyTypeLocale[strategyType]
            default:
                return CommonStrategyTypeLocale[StrategyTypeEnum.DEFAULT]
        }
    }
}

export const StrategyCreatorFormTypeEnum = {
    AIForm: 1,
    ManualForm: 2
}
//网格挂单模式和开单现价

export const GridModeGradeEnum = {
    model: {
        '2': {
            key: 'strategy_grid_text.equal_interval',
            text: '等比间隔'
        },
        '1': {
            key: 'strategy_grid_text.equidistant_interval',
            text: '等差间隔'
        }
    },
    modelGrade: {
        '0': {
            key: 'strategy_grid_text.not_have',
            text: '无'
        },
        '1': {
            key: '1%',
            text: ''
        },
        '2': {
            key: '2%',
            text: ''
        }
    }
}
export const getDetailProductDesc = (locale = 'en', isWise = true) => {
    const host = useHost()
    const wiseArticles = 'support/articles/12560603798425'
    const ctaArticles = 'support/articles/12560603794358'
    return `https://${host}/${locale === 'en' ? '' : `${locale}/`}${
        isWise ? wiseArticles : ctaArticles
    }`
}
export const getMoonProductDesc = (locale = 'en') => {
    const host = useHost()
    return `https://${host}/${locale === 'en' ? '' : `${locale}/`}support/articles/12560603799082`
}
export const geTimingProductDesc = (locale = 'en') => {
    const host = useHost()
    return `https://${host}/${locale === 'en' ? '' : `${locale}/`}support/articles/12560603791364`
}
export const getHoardProductDesc = (locale = 'en') => {
    const host = useHost()
    const articleLanguage = [
        'en',
        'es',
        'es-ES',
        'pt',
        'vi',
        'tr',
        'zh-TW',
        'zh-CN',
        'ru',
        'fr',
        'de',
        'it',
        'ja',
        'th',
        'pl',
        'id',
        'uk'
    ]
    const localeKey = articleLanguage.includes(locale) ? locale : 'en'
    return `https://${host}/${
        localeKey === 'en' ? '' : `${localeKey}/`
    }support/articles/12560603797355`
}

//定投内容
export const AutoInvestDateTypeEnum = {
    // 1按月定投  2按周定投  3按日定投   4按时定投
    month: 1,
    week: 2,
    day: 3,
    hour: 4
}

//获取可发布策略接口的策略类型
export const PublishStrategyTypeEnums = {
    'future-strategy': {
        grid: 2,
        dca: 4
    },
    'spot-strategy': {
        grid: 1,
        dca: 3,
        timing: 5,
        hoard: 19
    }
}

// 可发布策略接口的策略类型的lines类型
export enum PublishStrategyTypeEnumsLines {
    'futureStrategy' = 'future-strategy',
    'spotStrategy' = 'spot-strategy'
}

export const strategyUserType = {
    // 1 用户  2 交易员 3 策略提供者
    normalUser: 1,
    tradeUser: 2,
    creater: 3
}

/**
 * 获取AI策略列表参数
 *  5:策略-正向DCA 6：策略-反向DCA 7:策略-多头DCA 8:策略-空头DCA
 * normal
    reversel
 */
export const AIStrategyTypeEnum = {
    'future-strategy': {
        dca_1: 7, //多头dca
        dca_2: 8, //空头dca
        grid_3: 3, //多头网格
        grid_4: 4 //空头网格
    },
    'spot-strategy': {
        dca_1: 5, //正向dca
        dca_2: 6, //反向dca
        grid_1: 1, //正向网格
        grid_2: 2 // 反向网格
    }
}

export const typeEnums = {
    '1': 'dca.aggressive_text',
    '2': 'dca.robust_text',
    '3': 'dca.conservative_text',
    '4': 'ai_cta.MACD_strategy',
    '5': 'ai_cta.BOLL_strategy',
    '6': 'ai_cta.MA_strategy',
    '7': 'ai_cta.RSI_strategy'
}

export enum StrategyBusinessLine {
    FUTURE_STRATEGY = 'future-strategy',
    SPOT_STRATEGY = 'spot-strategy'
}
export enum StrategyEntryTabType {
    Manual,
    Bots
}

export const StrategyGridOrDca = {
    '1': 'grid',
    '2': 'dca',
    '5': 'timing',
    '8': 'cta',
    '10': 'wise',
    '12':'hoard'
}
// 一级策略类型  1:现货网格 2:合约网格  3:现货DCA. 4: 合约DCA. 15:现货CTA 16:合约CTA
// 用于/ai/selectAiStrategyList接口strategyType
export enum StrategyTypeForStrategyListEnum {
    SPOT_GRID = 1,
    FUTURE_GRID = 2,
    SPOT_DCA = 3,
    FUTURE_DCA = 4,
    SPOT_CTA = 15,
    FUTURE_CTA = 16
}

// 手动创建和ai创建
export enum aiStrategyManual {
    AI = 1, // 'macd'
    Manual = 2 // 'boll'
}

export enum StrategyCtaType {
    MACD = 4, // 'macd'
    BOLL = 5, // 'boll'
    MA = 6, // 'ma'
    RSI = 7 // 'rsi'
}

// cta策略 macd boll 区分
export enum StrategyCTAIndicatorType {
    macd = 1,
    boll = 2,
    ma = 4,
    rsi = 5
}

// 搜索策略类型
export const SearchStrategyTypeEnum = {
    dca: {
        'spot-strategy': 3, //现货dca
        'future-strategy': 4 //合约dca
    },
    grid: {
        'spot-strategy': 1, //现货网格
        'future-strategy': 2 //合约网格
    },
    cta: {
        'spot-strategy': 15,
        'future-strategy': 16
    },
    timing: {
        'spot-strategy': 7
    },
    wise: {
        'future-strategy': 17 // 合约智投
    },
    moon: {
        'spot-strategy': 22,
        'future-strategy': 21
    },
    hoard: {
        'spot-strategy': 19 //现货、合约维度的二级策略类型 strategySecondType: 19
    },
    tv: {
        'future-strategy': 20 //tradingview
    }
}

/**
 * 下单区正向，反向，中性
 */
export enum StrategyDirectTypes {
    Long = dcaTypes.long, //正向
    Short = dcaTypes.short, //反向
    Neutral = dcaTypes.neutral //中性
}
export const firstStrategyType = {
    '1': ['strategy.spot.grid', 'Spot grid'],
    '2': ['strategy.future.grid', 'Futures grid'],
    '3': ['strategy.spot.dca', 'Spot Martingale'],
    '4': ['strategy.future.dca', 'Futures Martingale'],
    '5': ['auto_invest.title', 'Auto Invest'],
    '7': ['auto_invest.title', 'Auto Invest'],
    '15': ['strategy.spot.cta', 'Spot CTA'],
    '16': ['strategy.future.cta', 'Futures CTA'],
    '19': ['strategy_hoard_coins.title', 'Smart Portfolio'],
    '22': ['strategy.spot.moon', 'Spot Moon'],
    '21': ['strategy.future.moon', 'Futures Moon']
}
export enum AiStategyTypeEnum {
    /**
     * 1:获取 网格、dca、cta数据
     */
    CTA = 1,

    HOARD = 2 // 默认查网格+dca 传1查网格+dca+cta  传2 +囤币宝
}

export const ctaFormDetail = {
    // 现货 businessLine 1
    '1': {
        // MACD aiType 4
        '4': {
            // direction 多头 1
            '1': {
                key: 'ai_cta.cta_spot_form_detail_macd_long_key1',
                default: '当快线上穿慢线(金叉时)，做多建仓',
                key1: 'ai_cta.cta_spot_form_detail_macd_long_key2',
                default1: '当快线下破慢线(死叉时)，平仓'
            },
            // direction 空头 2
            '2': {}
        },
        // BOLL aiType 5
        '5': {
            // direction 多头 1
            '1': {
                key: 'ai_cta.cta_spot_form_detail_bool_long_key1',
                default: '当K线价格由上向下穿过下轨时，建仓',
                key1: 'ai_cta.cta_spot_form_detail_bool_long_key2',
                default1: '当K线价格由下向上穿过中轨时，平仓'
            },
            // direction 空头 2
            '2': {}
        },
        '6': {
            // direction 多头 1
            '1': {
                key: 'ai_cta.cta_spot_form_detail_ma_long_key1',
                default:
                    'Go long when the short-term moving average crosses above the long-term moving average (golden cross).',
                key1: 'ai_cta.cta_spot_form_detail_ma_long_key2',
                default1:
                    'Go short when the short-term moving average crosses below the long-term moving average (death cross).'
            },
            // direction 空头 2
            '2': {}
        },
        '7': {
            // direction 多头 1
            '1': {
                key: 'ai_cta.cta_spot_form_detail_rsi_long_key1',
                default: 'Go long when the price breaks below the lower band.',
                key1: 'ai_cta.cta_spot_form_detail_rsi_long_key2',
                default1: 'Go short when the price breaks above the upper band.'
            },
            // direction 空头 2
            '2': {}
        }
    },
    // 合约 businessLine 10
    '10': {
        // MACD aiType 4
        '4': {
            // direction 多头 1
            '1': {
                key: 'ai_cta.cta_future_form_detail_macd_long_key1',
                default: '当快线上穿慢线(金叉时)做多建仓',
                key1: 'ai_cta.cta_future_form_detail_macd_long_key2',
                default1: '当快线下破慢线(死叉时)平仓'
            },
            // direction 空头 2
            '2': {
                key: 'ai_cta.cta_future_form_detail_macd_short_key1',
                default: '当快线下破慢线(死叉时)做空建仓',
                key1: 'ai_cta.cta_future_form_detail_macd_short_key2',
                default1: '当快线上穿慢线(金叉时)平仓'
            }
        },
        // BOLL aiType 5
        '5': {
            // direction 多头 1
            '1': {
                key: 'ai_cta.cta_future_form_detail_bool_long_key1',
                default: '当K线价格由上向下穿过下轨时，建仓',
                key1: 'ai_cta.cta_future_form_detail_bool_long_key2',
                default1: '当K线价格由下向上穿过中轨时，平仓'
            },
            // direction 空头 2
            '2': {
                key: 'ai_cta.cta_future_form_detail_bool_short_key1',
                default: '当K线价格由下向上穿过上轨时，建仓',
                key1: 'ai_cta.cta_future_form_detail_bool_short_key2',
                default1: '当K线价格由上向下穿过中轨时，平仓'
            }
        },
        '6': {
            // direction 多头 1
            '1': {
                key: 'ai_cta.cta_spot_form_detail_ma_long_key1',
                default:
                    'Go long when the short-term moving average crosses above the long-term moving average (golden cross).',
                key1: 'ai_cta.cta_spot_form_detail_ma_long_key2',
                default1:
                    'Go short when the short-term moving average crosses below the long-term moving average (death cross).'
            },
            // direction 空头 2
            '2': {
                key: 'ai_cta.cta_spot_form_detail_ma_long_key1',
                default:
                    'Go long when the short-term moving average crosses above the long-term moving average (golden cross).',
                key1: 'ai_cta.cta_spot_form_detail_ma_long_key2',
                default1:
                    'Go short when the short-term moving average crosses below the long-term moving average (death cross).'
            }
        },
        '7': {
            // direction 多头 1
            '1': {
                key: 'ai_cta.cta_spot_form_detail_rsi_long_key1',
                default: 'Go long when the price breaks below the lower band.',
                key1: 'ai_cta.cta_spot_form_detail_rsi_long_key2',
                default1: 'Go short when the price breaks above the upper band.'
            },
            // direction 空头 2
            '2': {
                key: 'ai_cta.cta_spot_form_detail_rsi_long_key1',
                default: 'Go long when the price breaks below the lower band.',
                key1: 'ai_cta.cta_spot_form_detail_rsi_long_key2',
                default1: 'Go short when the price breaks above the upper band.'
            }
        }
    }
}

/**
 * 双币列表key
 */
export enum DoubleCoinsType {
    Base = 1, // 左币
    Quote = 2, // 右币
    Double = 3 // 双币
}

/**
 * 现货网格屯币模式 1 开启
 */
export enum HoardBaseType {
    OFF = 0,
    ON = 1
}

/*
 * 中性网格的左右币动作
 */
export const ActionEnums = {
    SETQUOTE: 'setQuote', //设置右币
    SETAMOUNT: 'setAmount' //设置左币
}
/** 获取数量的动作 */
export const TypeEnums = {
    GETNUMS: 'getNums', //获取数量
    GETPROFIT: 'getProfit', //获取总数和收益
    ALL: 'all' //全部获取
}

export const StrategyMenuTab = {
    'spot-grid': 1,
    'futures-grid': 2,
    'spot-dca': 3,
    'futures-dca': 4,
    'auto-invest': 5,
    wise: 6
}

export const AIListType = {
    profit: 1,
    useCount: 2
}
export const StrategyTypeKeyName = {
    'spot-grid': 'Spot grid',
    'futures-grid': 'Futures grid',
    'spot-dca': 'Spot DCA',
    'futures-dca': 'Futures DCA',
    'auto-invest': 'Auto-invest strategy',
    'spot-hoard': 'Smart Portfolio',
    'futures-tv': 'Trading view',
    'spot-moon': 'Spot moon',
    'futures-moon': 'Futures moon'
}

export const fontWeightEnum = {
    500: 'font-medium',
    400: 'font-normal'
}

/**
 * 策略路由（当前用于H5底部导航跳转使用）
 * 业务线：USDT_MIX_CONTRACT_BL：合约业务线，SPOT_BL：现货业务线
 * 策略类型：
 * grid：网格策略
 * moon：天地网格策略
 * timing：现货定投策略
 * hoard：囤币宝策略
 * dca：DCA策略
 * cta：CTA策略
 * tv：TradingView策略
 * wise：合约量化策略
 * 备注：后续新增策略需要在此处添加
*/
export const H5NavStrategyRouter = {
    grid: {
        [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: '/trading-bot/futures',
        [BusinessLineEnum.SPOT_BL]: '/trading-bot/spot'
    },
    moon: {
        [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: '/trading-bot/futures/moon',
        [BusinessLineEnum.SPOT_BL]: '/trading-bot/spot/moon'
    },
    timing: {
        [BusinessLineEnum.SPOT_BL]: '/trading-bot/spot/timing'
    },
    hoard: {
        [BusinessLineEnum.SPOT_BL]: '/trading-bot/spot/hoard'
    },
    dca: {
        [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: '/trading-bot/futures/dca',
        [BusinessLineEnum.SPOT_BL]: '/trading-bot/spot/dca'
    },
    cta: {
        [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: '/trading-bot/futures/cta',
        [BusinessLineEnum.SPOT_BL]: '/trading-bot/spot/cta'
    },
    wise: {
        [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: '/trading-bot/futures/wise',
    },
    tv: {
        [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: '/trading-bot/futures/tv',
    },
}

export const NavStrategyTypeEnum = {
    dca: {
        [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: 'futures-dca',
        [BusinessLineEnum.SPOT_BL]: 'spot-dca'
    },
    grid: {
        [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: 'futures-grid',
        [BusinessLineEnum.SPOT_BL]: 'spot-grid'
    },
    cta: {
        [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: 'futures-cta',
        [BusinessLineEnum.SPOT_BL]: 'spot-cta'
    },
    timing: {
        [BusinessLineEnum.SPOT_BL]: 'spot-timing'
    },
    wise: {
        [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: 'futures-wise'
    },
    hoard: {
        [BusinessLineEnum.SPOT_BL]: 'hoard'
    },
    tv: {
        [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: 'futures-tv'
    },
    moon: {
        [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: 'futures-moon',
        [BusinessLineEnum.SPOT_BL]: 'spot-moon'
    }
}

// 囤币宝平衡模式
export enum BalanceType {
    Time = 1,
    Ratio = 2
}
// 囤币宝平衡模式
export enum BalanceTimeType {
    Hour = 1,
    Minute = 2
}
/**
 * 定投ai推荐策略的筛选顺序
 */
export enum AutoInvestListType {
    years5 = 6,
    years3 = 5,
    years1 = 4,
    yearsHalf = 3,
    month3 = 2,
    month1 = 1
}

// 二级策略类型
export const SecondStrategyType = {
    '1': {
        spot: 19,
        futures: 21
    },
    '2': {
        spot: 20,
        futures: 22
    }
}

/**
 *  开启移动：1开启 0关闭
 */
export enum EnableMoveTypes {
    Off,
    On
}

// 是否启动移动网格
export const EnableMoveType = {
    open: 1,
    close: 0
}

/**
 * 信号数据的标识，不为1 都是warning信息
 */
export const MSGTYPE = {
    info: 1,
    warning: 2,
    error: 3
}

/**
 * 囤币宝的ai列表类型
 */
export const HORD_RECOMMEND_TYPE = {
    ai: 1,
    academy: 2
}

/**
 * 信号策略的下单失败原因状态
 */
export const StrategySignReason = {
    1: 'strategy.sign.not_sign', //非进出场信号
    2: 'strategy.sign.little_amount', // 可用资金不足
    3: 'strategy.sign.little_min_amount', // 不满足最小下单金额
    4: 'strategy.more_max_amount', // 超过最大下单金额
    5: 'trade.plan.fail_reason_20003' // 下单失败
}


/**
 * 囤币宝成交明细事件名称
 */
export const HoardEventType = {
    1: 'strategy_hoard_coins.init_position_building', //初始建仓
    2: 'strategy_hoard_coins.add_investment', // 追加投入
    3: 'strategy_hoard_coins.warehouse_adjustment', // 调仓
    4: 'strategy_hoard_coins.profit_extraction', // 利润提取
    5: 'strategy_hoard_coins.termination_of_sale', // 终止卖出
    6: 'strategy_hoard_coins.params_edit' // 参数调整
}

/**
 * 信号数据的标识，不为1 都是warning信息
 */
export const MSGTYPEENUM = {
    0: 'All',
    1: 'info',
    2: 'error',
    3: 'warning'
}

/**
 * 信号订单的状态默认值
 * 1未撮合，2撮合已处理，3部分成交，4完全成交，5撤销，6拒单
 */
export const tvOrderStatusNum = {
    1: 'Not matched',
    2: 'Matching processed',
    3: 'Partially filled',
    4: 'Completely filled',
    5: 'Cancel',
    6: 'Rejected'
}

/**
 * 信号订单的状态默认值
 * 1未撮合，2撮合已处理，3部分成交，4完全成交，5撤销，6拒单
 */
export const tvOrderErrorNum = {
    not_open_close_signal: '非进出场信号，下单失败',
    balance_not_enough: '可用资金不足，下单失败',
    less_than_min_delegate_amount: '不满足最小下单金额，下单失败',
    more_than_max_delegate_amount: '超过最大下单金额限制，下单失败'
}

/**
 * TV信号跟随起点
 * 0:仓位0开始跟随，1：第一个信号
 */
export enum StartTimingTypes {
    Script,
    First
}

/*
 * 收益的出入来源
 * 1 保证金
 * 2 利润
 */
export const AmountBizType = {
    invest: 1,
    proft: 2
}
/*
 * cta策略卡片与k线对应的周期map, key cta interval, value kline interval
 * CTA K线周期 （1 5 30 60 单位为分钟）
 * kline： 0: 1m, 1: 3m, 2: 5m, 3:15, 4: 30m
 * 10: 1h, 11: 2h, 12: 4h, 13: 6h, 14: 8h, 15: 12h
 * 20: 1D, 21: 3D, 22: 7D, 23: 30D
 */
export const CTA_INTERVAL_KLINE_MAP = {
    1: 0,
    3: 1,
    5: 2,
    15: 3,
    30: 4,
    60: 10,
    120: 11,
    240: 12,
    360: 13,
    480: 14,
    720: 15,
    1440: 20,
    4320: 21,
    10080: 22,
    43200: 23
}

/**
 * cta策略卡片与k线对应的主图map, key cta indicatorType, value kline study
 * CTA K线周期 1：macd， 2：boll 4: ma 5:rsi
 * kline： 0: 1m, 2: 5m, 4: 30m, 10: 1h
 */
export const CTA_STUDY_KLINE_MAP = {
    1: 'MACD',
    2: 'BOLL',
    4: 'MA',
    5: 'RSI'
}

/**
 * 二级策略类型
 * 1:正向网格 2: 反向网格
 * 3:多头网格 4: 空头网格
 * 5:正向DCA 6:反向DCA
 * 7:多头DCA 8:空头DCA
 * 10: 正向CTA 11:多头CTA 12:空头CTA
 * 19:正向天地网格 20:反向天地网格
 * 21:多头天地网格 22:空头天地网格
 */

export const enum StrategySecondTypes {
    GRID_WORLD_POSITIVE = 19, // 19 正向天地网格
    GRID_WORLD_NEGATIVE, // 20:反向天地网格
    GRID_WORLD_LONG, // 21:多头天地网格
    GRID_WORLD_SHORT // 22:空头天地网格
}

/**
 * 体验券接口
 */
export const enum StrategyCouponType {
    TrialFee = 'trialFee'
}

/**
 * 策略体验券弹窗与 策略新增弹窗冲突时记录状态
 */
export const enum StrategyCouponGuideStatus {
    UnFetch, // 未请求接口
    Show, // 请求接口后需要显示体验券弹窗
    Hide // 请求接口后不需要显示体验券弹窗
}

/**
 * 策略类型映射
 */
export const StrategyTypeMap = {
    [BusinessLineEnum.SPOT_BL]: 'spot',
    [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: 'futures'
}

export const enum StrategyCardDetailHistoryType {
    History = 'history',
    Current = 'current'
}

/**
 *
 * 策略来源
 */
export const StrategySourceMap = {
    1: 'strategy_grid_text.self_created',
    2: 'c2c_order.buy',
    3: 'strategy_grid_text.subscription'
}

export const enum StrategySourceType  {
   SelfCreated =  1,
   Buy= 2,
   Copy = 3 //订阅
}

export const enum StrategyDelegateType  {
    Buy= 21, //买入
    Sell = 22 //卖出
 }

/**
 *
 * 发布策略弹窗简介数据
 */
export function strategyLineToIntroLabelList(t,type) {
    return (
        {
            1: [
                {
                    value: 1,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc1')
                },
                {
                    value: 2,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc2')
                },
                {
                    value: 3,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc3')
                }
            ], //现货网格
            2: [
                {
                    value: 4,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc4')
                },
                {
                    value: 5,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc5')
                },
                {
                    value: 6,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc6')
                }
            ], // 合约网格
            8: [
                {
                    value: 1,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc1')
                },
                {
                    value: 2,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc2')
                },
                {
                    value: 3,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc3')
                }
            ], //现货中性
            9: [
                {
                    value: 4,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc4')
                },
                {
                    value: 5,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc5')
                },
                {
                    value: 6,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc6')
                }
            ], // 合约中性
            3: [
                {
                    value: 7,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc7')
                },
                {
                    value: 8,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc8')
                },
                {
                    value: 9,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc9')
                }
            ], // 现货马丁格尔
            4: [
                {
                    value: 10,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc10')
                },
                {
                    value: 11,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc11')
                },
                {
                    value: 12,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc12')
                }
            ], // 合约马丁格尔
            7: [
                {
                    value: 13,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc13')
                },
                {
                    value: 14,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc14')
                },
                {
                    value: 15,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc15')
                }
            ], // 现货定投
            15: [
                {
                    value: 16,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc16')
                },
                {
                    value: 17,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc17')
                },
                {
                    value: 18,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc18')
                }
            ], // 现货CTA
            16: [
                {
                    value: 19,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc19')
                },
                {
                    value: 20,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc20')
                },
                {
                    value: 21,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc21')
                }
            ], // 合约CTA
            22: [
                {
                    value: 22,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc22')
                },
                {
                    value: 23,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc23')
                },
                {
                    value: 24,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc24')
                }
            ], //现货天地网格
            21: [
                {
                    value: 25,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc25')
                },
                {
                    value: 26,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc26')
                },
                {
                    value: 27,
                    label: t('strategy_grid_text.strategy_introduce_brief.desc27')
                }
            ] //合约天地网格
        }[type] || ''
    )
}
export const strategyPublishStatus = {
    2: 'strategy_grid_text.pub_btn',
    1: 'strategy_grid_text.off_shelf'
}

/**
 *
 * 发布状态
 */

export const strategyPublishStatusMap = {
    publish: 1,
    removeShelves: 2
}
/**
 * 追踪单-复合
 * 1.未撮合；2.撮合已处理；3.部分成交；4.完全成交；5.撤销；6.拒单
 */
export const enum TrackingOrdersStateEnum {
    unmatched = 1,
    matched = 2,
    part = 3,
    complete = 4,
    cancel = 5,
    reject = 6
}
/*
 * TV信号进场设定
 * 1.TV信号 2.占可用保证金比例 3.固定金额
 */
export const enum SignInputTypes {
    Sign = 1, // TV信号
    Ratio = 2, // 占可用保证金比例
    Amount = 3 // 固定金额
}

/**
 * 允许多次进场
 * 0 不可重入 1可重入
 */
export const enum SignReentrantTypes {
    Off,
    On
}

/**
 * dca 开始条件
 *  1上次循环平仓均价、2 RSI、3 BOLL
 * 4 、5 属于 自定义类型，用于前端下拉框显示 不传入后端
 */
export const enum TriggerIndicatorTypes {
    LoopAvgPrice = 1, // 循环均价
    RSI = 2,
    BOLL = 3,
    Immediate = 4, // 立即触发
    Price = 5 // 价格触发
}

/**
 * grid 开始条件
 * 0.价格触发（包含当前、价格） 1RSI指标 2 BOLL指标
 */
export const enum GridTriggerIndicatorTypes {
    RSI = 1,
    BOLL = 2,
    Immediate = 3, // 立即触发
    Price = 4 // 价格触发
}

/**
 * 1 市价 2 限价
 */
export const enum DCAInvestTypes {
    Market = 1,
    Limit = 2
}
//  1. 多头进场 2. 多头离场 3. 空头进场 4 空头离场 5 仓位反转
export const signalMap = {
    '1': {
        id: 'strategy_detail.ENTER_LONG',
        defaultMessage: '多头进场'
    },
    '2': {
        id: 'strategy_detail.EXIT_LONG',
        defaultMessage: '多头离场'
    },
    '3': {
        id: 'strategy_detail.ENTER_SHORT',
        defaultMessage: '空头进场'
    },
    '4': {
        id: 'strategy_detail.EXIT_SHORT',
        defaultMessage: '空头离场'
    },
    '5': {
        id: 'strategy_detail.REVERSAL',
        defaultMessage: '仓位反转'
    }
}

// dca 高级设置-RSI—BOLL k线周期列表
export const DCAKLineList = [
    { name: '1m', key: 1 },
    { name: '5m', key: 5 },
    { name: '15m', key: 15 },
    { name: '30m', key: 30 },
    { name: '1H', key: 60 },
    { name: '4H', key: 240 },
    { name: '1D', key: 1440 },
]

/**
 * 预计亏损预留 1预留 0不预留	
 */
export const enum GridLossReserveTypes {
    OFF,
    ON
}

export const aiSrcTypeMap = {
    ai: 1,
    followOrder: 2
}

// 跟单快捷下单 判断反向字段
export const QuickOrderSecondStrategyType =  {
    GridReverse: 2, // 反向网格
    DcaReverse: 6, // 反向dca
}

// 跟单快捷下单 两种下单模式
export const QuickOrderFollowOrderType =  {
    buy: 'buy',
    copy: 'copy'
}

// 跟单快捷下单 不同类型弹窗
export const QuickOrderFollowOrderResultType =  {
    BuySuccess: 0, //  buy 从未购买 交易成功
    BuyFail: 1, // buy 从未购买 交易失败
    CopyFail: 2, // copy 复制策略时，运行失败
}


// 跟单快捷下单 不同类型弹窗
export const RunAndPauseMap =  {
    Start: 1, // 运行
    Pause: 2, // 暂停
}
